import React, {useEffect, useRef} from 'react';
import BankGraphic from '../../../static/images/utils/bank-1.svg'
import DropdownItem from "../../Atoms/Items/DropdownItem";
import DropdownButton from "../Dropsdown/DropdownButton";
import DeleteModal from "../../Organisms/Modals/DeleteModal";

const BankItem = () => {
  const deleteModal = useRef()
  const handleOpenDeleteModal = () => {
    deleteModal.current.openModal()
  }

  return (
    <>
      <article className="flex nowrap s-mb-0">
        <img
          src={BankGraphic}
          className="s-mr-8px flex-none"
        />
        <div>
          <p className="s-mb-0 small">BBVA Colombia</p>
          <p className="s-mb-0 s-color-light-text smaller">Cuenta - 3452 5324 32</p>
        </div>
        <DropdownButton
          className="s-to-right"
          icon="vertical-dots"
        >
          <DropdownItem text="Editar"/>
          <DropdownItem text="Eliminar" onClick={handleOpenDeleteModal} />
        </DropdownButton>
      </article>
      <DeleteModal
        ref={deleteModal}
      />
    </>
  );
};

export default BankItem;
